"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FilterColumn;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _filterCategoryMobile = _interopRequireDefault(require("./filter-category-mobile"));
var _filterCategory = _interopRequireDefault(require("./filter-category"));
var _filterStatus = _interopRequireDefault(require("./filter-status"));
var _filterKeyword = _interopRequireDefault(require("./filter-keyword"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _react2 = require("@linaria/react");
var _card = _interopRequireDefault(require("@ux/card"));
var _text = _interopRequireDefault(require("@ux/text"));
const FilterColumnContainer = /*#__PURE__*/(0, _react2.styled)(_card.default)({
  name: "FilterColumnContainer",
  class: "pl-f150zvvg"
});
function FilterColumn({
  categoryList,
  checkedCategory,
  statusList,
  keyword,
  categoryTitle,
  viewAllCategoryLabel,
  followingCategoryLabel,
  statusTitle,
  keywordTitle,
  keywordPlaceholder,
  categoryCounts,
  statusCounts,
  handleSearch,
  handleCategorySelection,
  handleStatusSelection,
  isMobile
}) {
  return /*#__PURE__*/_react.default.createElement(FilterColumnContainer, {
    "data-cy": "gtld-filter-column"
  }, isMobile && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", null, categoryTitle), /*#__PURE__*/_react.default.createElement(_filterCategoryMobile.default, {
    checkedCategory,
    categoryList,
    categoryCounts,
    handleCategorySelection
  })), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title"
  }, keywordTitle), /*#__PURE__*/_react.default.createElement(_filterKeyword.default, {
    keyword,
    handleSearch,
    keywordPlaceholder
  })), !isMobile && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title"
  }, statusTitle), /*#__PURE__*/_react.default.createElement(_filterStatus.default, {
    statusList,
    statusCounts,
    handleStatusSelection
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title"
  }, categoryTitle), /*#__PURE__*/_react.default.createElement(_filterCategory.default, {
    checkedCategory,
    categoryList,
    viewAllCategoryLabel,
    followingCategoryLabel,
    categoryCounts,
    handleCategorySelection
  })));
}
FilterColumn.propTypes = {
  categoryList: _propTypes.default.array,
  checkedCategory: _propTypes.default.number,
  statusList: _propTypes.default.array,
  keyword: _propTypes.default.string,
  categoryTitle: _propTypes.default.string,
  viewAllCategoryLabel: _propTypes.default.string,
  followingCategoryLabel: _propTypes.default.string,
  statusTitle: _propTypes.default.string,
  keywordTitle: _propTypes.default.string,
  keywordPlaceholder: _propTypes.default.string,
  categoryCounts: _propTypes.default.object,
  statusCounts: _propTypes.default.object,
  handleSearch: _propTypes.default.func,
  isMobile: _propTypes.default.bool.isRequired,
  handleCategorySelection: _propTypes.default.func,
  handleStatusSelection: _propTypes.default.func
};